module.exports = __webpack_public_path__ + "static/media/Манаков И., Келлер А..f0699457.pdf";